import React, { useRef, useState, useEffect } from "react";
import {useApiManager} from "lib/ApiContext";
import EventNeonCard from "./EventNeonCard"
import {Stack, Box, Typography} from '@mui/material';
import { useNavigate } from "react-router";



const PartnerList = ({eventID}) => {

    const [partners, setPartners] = useState([]);
    const api = useApiManager();
    const navigate = useNavigate();

    const fetchData = async () =>{
        try {
            const data = await api.GetEventPartner (eventID);
            const pList = []; 
                for(var i=0;i<data.count;i++){ 
                    const creator = await api.GetCreator(data.items[i].CreatorID);
                    pList.push(creator);
                }

            setPartners(pList);
        }
        catch (error){
            console.error("❌ Error al cargar los eventos:", error);
        }
    }

    useEffect(() => {
        fetchData();
    },[]);

    return <Stack direction="row" spacing={2}   
                            justifyContent="flex-start"  
                            alignItems="center"      
                            sx={{ flexWrap: "wrap", margin:2 }}
                            > 
                {partners?.map((p, i) => (
                    <Box sx={{display:"flex", alignItems:"center", padding:1, pl:2, pr:2, backgroundColor:"#3333337e", borderWidth:1, borderRadius:4, borderColor:"black" }} key={i}>
                    <Typography key={i} onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/creators/${p.Nickname}`);
                      }} sx={{'&:hover':{cursor:"pointer", color:"yellow"}}} > 
                        @{p.Nickname}
                    </Typography>
                    </Box>
                    ))
                }
           </Stack>;
}

export default PartnerList;
